import midBannerFormSaga from 'features/marketplace/operation/midBanner/midBannerFormSaga';
import midBannerSaga from 'features/marketplace/operation/midBanner/midBannerSaga';
import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import mainBannerSaga from './operation/mainBanner/mainBannerSaga';
import mainBannerFormSaga from './operation/mainBannerForm/mainBannerFormSaga';

function* marketplaceSaga(): SagaIterator {
  yield all([
    fork(midBannerSaga),
    fork(mainBannerSaga),
    fork(midBannerFormSaga),
    fork(mainBannerFormSaga),
  ]);
}

export default marketplaceSaga;
